import React, { Component } from 'react';

import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';

class HandStrengthChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tData: []
        }
    }

    transformData = (handRankData) => {
        let newRankData = JSON.parse(JSON.stringify(handRankData))

        for (let i = 0; i < newRankData.length; i++) {
            newRankData[i].name = "R" + newRankData[i].rank + " - " + newRankData[i].hand
        }

        return newRankData
    }

    

    componentDidUpdate (prevProps, prevState) {
        if(this.props.handRankData !== prevProps.handRankData) {
            this.setState({
                tData: this.transformData(this.props.handRankData)
            })
        }
    }

    render() {
        const CustomTooltip = ({ active, payload, label }) => {
            if (active) {
                return (
                <div className="custom-tooltip">
                    <p className="label"><b>{`${payload[0].payload.name}`}</b></p>
                    <p className="label">{`6p. odds: ${payload[0].value}%`}</p>
                    <p className="label">{`9p. odds: ${payload[1].value}%`}</p>
                </div>
                );
            }
          
            return null;
        };

        const xTicks = Array.from({ length: 18}, (_, i) => 0 + (i*10))
        const yTicks = Array.from({ length: 6}, (_, i) => 0 + (i*10))

        return (
            <ResponsiveContainer width="100%" height={300}>
                <LineChart  data={this.state.tData}>
                    <XAxis type="number" dataKey="rank" domain={[0, 'dataMax']} ticks={xTicks}/>
                    <YAxis ticks={yTicks} label={{ value: 'Win odds (%)', angle: -90, position: 'insideLeft' }}/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Tooltip content={<CustomTooltip />}/>
                    <Legend />
                    <Line type="monotone" dataKey="odds_6p" stroke="#8884d8" dot={false}/>
                    <Line type="monotone" dataKey="odds_9p" stroke="#82ca9d" dot={false}/>
                </LineChart>
            </ResponsiveContainer>
        )
    }
}

export default HandStrengthChart;
